import React, { useEffect } from 'react';
import { toast, ToastContainer } from 'react-toastify';
import styled from 'styled-components';
import { injectStyle } from 'react-toastify/dist/inject-style';

const AUTO_CLOSE_TIME_OUT = 5000;

const NotificationRootComponent = () =>
{
    useEffect( () => {
        injectStyle();
    }, []);

    return <ToastContainerWithCustomStyles
        position={toast.POSITION.TOP_RIGHT}
        autoClose={AUTO_CLOSE_TIME_OUT}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        hideProgressBar
        pauseOnHover
    />;

};


export default NotificationRootComponent;

const ToastContainerWithCustomStyles = styled( ToastContainer )`
  .Toastify__toast--error {
    color: #AB2205;
    background-color: #FDD9D0;
    font-family: ${props => props.theme.fonts.regular};
    
    .Toastify__close-button {
      color: #AB2205;
    }
  }
  
  .Toastify__toast--info {
    color: #073454;
    background-color: #DDECF6;
    font-family: ${props => props.theme.fonts.regular};
    
    .Toastify__close-button {
      color: #073454;
    }
  }
  
  .Toastify__toast--success {
    color: #4D6F3A;
    background-color: #A8D78E;
    font-family: ${props => props.theme.fonts.regular};
    
    .Toastify__close-button {
      color: #4D6F3A;
    }
  }
`;
